export default {
  API_ERROR: "Vi beklager, der skete en fejl. Prøv venligst igen.",
  FORM_ERROR: "Vi beklager, men du er nødt til at skrive lidt mere for at dele din feedback med os."
}